<template>
  <main>
    <DetailAwards />
  </main>
</template>

<script>
const DetailAwards = () => import('@/components/Awards/Categories/Detail')

export default {
  components: {
    DetailAwards
  },
  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: 'https://admanawards.com' },
      { name: 'og:title', content: 'Adman Awards & Symposium 2019' },
      { name: 'og:description', content: 'งานประกวด แสดงผลงาน และแลกเปลี่ยนเรียนรู้ ของคนในวงการโฆษณาและการสื่อสารการตลาด' },
      { name: 'og:image', content: 'https://admanawards.com/img/og_adman.jpg' },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
</style>
